import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { CampaignClass } from '@feathr/blackbox';
import { CampaignLabelMap } from '@feathr/blackbox';
import { Pill } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

import { campaignColorMap } from '../../styles/campaign';
import { getCampaignIcon } from '../CampaignIcons';

interface IProps {
  className?: string;
  cls: CampaignClass;
  name?: string;
  isLoading?: boolean;
  /** Whether or not the campaign is for monetization. Default is false */
  isMonetization?: boolean;
  /** When true (default), truncates label text. Set to false to show full label. */
  truncate?: boolean;
}

function CampaignTypeChip({
  className,
  cls,
  name,
  isLoading = false,
  isMonetization = false,
  truncate = false,
}: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Pill
      className={className}
      isLoading={isLoading}
      name={name ?? 'campaign-type-chip'}
      prefix={getCampaignIcon(cls)}
      suffix={isMonetization && getIconForAction('monetization')}
      theme={campaignColorMap.get(cls)}
      truncate={truncate}
    >
      {CampaignLabelMap.get(cls) ?? t('Campaign')}
    </Pill>
  );
}

export default CampaignTypeChip;
